import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'
import './i18n'
import './index.css'
import App from './App.tsx'
mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  autocapture: true,
  record_sessions_percent: 100,
  api_host: 'https://api-eu.mixpanel.com',
  opt_out_tracking_by_default: import.meta.env.VITE_MIXPANEL_ENABLED === 'false',
  opt_out_persistence_by_default: import.meta.env.VITE_MIXPANEL_ENABLED === 'false',
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
